import type * as Schema from 'owa-graph-schema';
import { onFolderHierarchyResponse } from '../actions/onFolderHierarchyResponse';
import getFolderTable from '../selectors/getFolderTable';
import { isStringNullOrWhiteSpace } from 'owa-localize';
import { setFolderTreeData } from '../mutators/setFolderTreeData';
import FolderTreeLoadStateEnum from '../store/schema/FolderTreeLoadStateEnum';
import { addFolderToDefaultFolderMappings } from 'owa-session-store';
import { orchestrator } from 'satcheljs';
import { createOrGetFolder } from './helpers/createOrGetFolder';
import { updateFolderTable } from './helpers/updateFolderTable';

/**
 * Orchestrator that updates the folder table and sets-up parent child folder relations
 * for gql folder hierarchy response.
 */
export const onFolderHierarchyResponseOrchestrator = orchestrator(
    onFolderHierarchyResponse,
    actionMessage => {
        const {
            displayName,
            folders,
            folderTreeIdentifier,
            includesLastItemInRange,
            offset,
            principalSMTPAddress,
            rootFolder,
            userIdentity,
        } = actionMessage;

        const createOrGetFolder_0 = (folder: Schema.MailFolder) => {
            return createOrGetFolder(folder, principalSMTPAddress);
        };

        updateFolderTable(displayName, rootFolder, folders, createOrGetFolder_0);

        setFolderTreeData(
            folderTreeIdentifier,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (41,13): Argument of type 'MailFolder | undefined' is not assignable to parameter of type 'MailFolder'.
            // @ts-expect-error
            getFolderTable().get(rootFolder.id),
            FolderTreeLoadStateEnum.Loaded,
            !includesLastItemInRange, // HasMoreData = !IncludesLastItemInRange
            offset,
            userIdentity
        );

        // We have seen instances of stale data in SessionSettings (DefaultFolder Names and Ids)
        // Replace the data with what FindFolder returns for folders with known names (DistinguishedFolderId names)
        const mailboxType = rootFolder.mailboxInfo.type;
        const rootFolderId = rootFolder.id;
        if (mailboxType === 'UserMailbox' || mailboxType === 'ArchiveMailbox') {
            for (let i = 0; i < folders.length; i++) {
                const rawFolder = folders[i];
                const folderId = rawFolder.id;
                const distinguishedFolderType = rawFolder.distinguishedFolderType;

                const shouldAdd =
                    (mailboxType === 'UserMailbox' || rawFolder.parentFolderId == rootFolderId) &&
                    !isStringNullOrWhiteSpace(distinguishedFolderType);

                if (shouldAdd) {
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2345 (66,54): Argument of type 'Maybe<string> | undefined' is not assignable to parameter of type 'string'.
                    // @ts-expect-error
                    addFolderToDefaultFolderMappings(distinguishedFolderType, folderId);
                }
            }

            // Also update the rootFolder's folderNameToId mapping, to make sure we don't have stale entry for it
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (74,46): Argument of type 'Maybe<string> | undefined' is not assignable to parameter of type 'string'.
            // @ts-expect-error
            addFolderToDefaultFolderMappings(rootFolder.distinguishedFolderType, rootFolderId);
        }
    }
);
